import {
	AOFL_PRODUCT_NAMES,
	AOFL_PRODUCT_UUIDS,
	LINK_FROM_APP_PLATFORMS
} from '$lib/utils/constants';
import { has2_0Account } from '$lib/utils/aofl-accounts';
import { app } from '$lib/stores/app/store';
import { get } from 'svelte/store';
import { ProductExperienceService } from '$lib/services/product-experience';
import { isFeatureFlagEnabled } from '$lib/services/experiments';
import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentService } from '$lib/services/experiments/client';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	browserLinkFromApp2_0: {
		condition: async () => {
			// This handles iOS app users in 2.0 experience that link out to the sub page
			const isFeatureFlag2_0 = isFeatureFlagEnabled('2_0_test');
			const isIOSPlatform = get(app)?.global.linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS;
			const is2_0 =
				ProductExperienceService.AOFL_PRODUCT_UUID === AOFL_PRODUCT_UUIDS.ABCMOUSE_2_0 ||
				isFeatureFlag2_0;
			return isIOSPlatform && is2_0;
		},
		resolve: async () => {
			return await import('../_browser-2-0-rebrand/Page.svelte');
		}
	},
	browserLinkFromApp: {
		condition: async () => {
			// This handles iOS app users in 1.0 experience that link out to the sub page
			return get(app)?.global.linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS;
		},
		resolve: async () => await import('../_browser/Page.svelte')
	},
	inApp: {
		condition: async (config) => {
			return config?.global?.appProduct !== AOFL_PRODUCT_NAMES.ABCMOUSE_2_0 && config.meta.inApp;
		},
		resolve: async () => await import('../../inside-pw/_in-app/Page.svelte')
	},
	inApp2_0: {
		condition: async (config) => {
			return config?.global?.appProduct === AOFL_PRODUCT_NAMES.ABCMOUSE_2_0 && config.meta.inApp;
		},
		resolve: async () => await import('../_in_app_2-0/Page.svelte')
	},
	browser_2_0_Rebrand: {
		condition: async () => {
			const isFeatureFlagRebrand = isFeatureFlagEnabled('2_0_rebrand');
			const isRebrandExperimentActive = await experimentService.isAnyExperimentArmActive(
				ACTIVE_EXPERIMENTS.ABCM2_REBRAND.experimentKey,
				[ACTIVE_EXPERIMENTS.ABCM2_REBRAND.variants.test],
				{
					page_name: 'download-app',
					page_url: '/abc/download-app'
				}
			);

			return has2_0Account() && (isRebrandExperimentActive || isFeatureFlagRebrand);
		},
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte')
	},
	browser_2_0_Rebrand_Safari: {
		condition: async () => {
			const isFeatureFlagRebrand = isFeatureFlagEnabled('2_0_rebrand');
			const isRebrandExperimentActive = await experimentService.isAnyExperimentArmActive(
				ACTIVE_EXPERIMENTS.ABCM2_REBRAND_SAFARI.experimentKey,
				[ACTIVE_EXPERIMENTS.ABCM2_REBRAND_SAFARI.variants.test],
				{
					page_name: 'download-app',
					page_url: '/abc/download-app'
				}
			);

			return has2_0Account() && (isRebrandExperimentActive || isFeatureFlagRebrand);
		},
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte')
	},
	browser_2_0_Rollout: {
		condition: async () => {
			return has2_0Account();
		},
		resolve: async () => await import('../_browser-2-0-rollout/Page.svelte')
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte')
	}
};

export { pageConditions };
